<template>
  <div class="img-uploader position-relative">
    <v-form
      ref="form"
      v-model="valid"
    >
      <v-file-input
        ref="uploader"
        outlined
        :hide-details="hideDetails"
        :single-line="singleLine"
        :rules="required ? requiredRules : []"
        :value="value"
        dense
        prepend-icon=""
        :disabled="disabled"
        :label="$store.getters.languageGetter === '1' ? 'مرفق' : 'Attachment'"
        clearable
        append-icon="mdi-paperclip"
        accept="*"
        :truncate-length="truncateLength"
        class="rounded-top-0"
        @change="getImg"
        @click:clear="$emit('update:delete')"
      />
      <!-- <div
        style="border:1px solid #ccc !important;width:38px;height:38px;position:absolute;left: 100%;top:0;"
        class="ml-2 rounded"
      >
        <div
          class="popup"
          style="position:absolute;z-index:1000;top:0;right:0;bottom:0;left:0"
          @mouseenter="popupHover = true"
          @mouseleave="popupHover = false"
        />
        <v-img
          :src="imgUrl"
          class="grey lighten-5 d-flex align-center text-center "
          style="width:36px;height:36px;"
          contain
        >
          <template v-slot:placeholder>
            <v-row
              v-if="image"
              class="fill-height ma-0"
              align="center"
              justify="center"
            >
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              />
            </v-row>
          </template>
        </v-img>
        <v-card
          v-if="popupHover"
          elevation="1"
          style="position:absolute;z-index:1;left: 120%; top: -100%;max-width:initial"
          :style="`width:${popWidth}px;height:${popHeight}px`"
          @mouseleave="popupHover = false"
        >
          <v-img
            :src="imgUrl"
            class="grey lighten-5 d-flex align-center text-center "
            contain
          >
            <template v-slot:placeholder>
              <v-row
                v-if="image"
                class="fill-height ma-0"
                align="center"
                justify="center"
              >
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                />
              </v-row>
            </template>
          </v-img>
        </v-card>
      </div> -->
      <v-dialog
        v-if="dialog"
        :value="true"
        persistent
        width="300"
      >
        <v-card
          dark
          color="white"
        >
          <v-progress-linear indeterminate />
        </v-card>
      </v-dialog>
    </v-form>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ImgUploadInput',
  props: {
    aspectRatio: {
      type: String,
      default: '1',
    },
    image: {
      type: String,
      default: '',
    },
    popWidth: {
      type: String,
      default: '38px',
    },
    popHeight: {
      type: String,
      default: '38px',
    },
    bestSize: {
      type: String,
      default: '',
    },
    dir: {
      type: String,
      default: 'product',
    },
    label: {
      type: String,
      default: '',
    },
    iconSize: {
      type: String,
      default: '24px',
    },
    placeholder: {
      type: String,
      default: '选择图片',
    },
    showInput: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      default: true,
    },
    singleLine: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    delIconSize: {
      type: String,
      default: 'default',
    },
    validate: {
      type: Boolean,
      default: false,
    },
    truncateLength: {
      type: Number,
      default: 50,
    },
  },
  data() {
    return {
      dialog: false,
      popupHover: false,
      valid: true,
      requiredRules: [(v) => !!v || `请上传${this.label}`],
      value: null,
    };
  },
  computed: {
    imgUrl() {
      return process.env.VUE_APP_API + this.image;
    },
  },
  watch: {
    validate() {
      this.validateForm();
    },
  },
  methods: {
    ...mapActions(['uploadImgSync']),
    getImgClick() {
      this.$refs.uploader.$refs.input.click();
    },
    getImg(file) {
      if (!file) {
        return;
      }
      this.dialog = true;
      const postData = new FormData();
      postData.append('file', file);
      postData.append('dir', this.dir);
      this.uploadImgSync(postData)
        .then((res) => {
          console.log('函数 ~ file: ImgUploadInput.vue ~ line 205 ~ .then ~ res', res);
          this.$emit('update:src', res);
          this.value = file;
        })
        .catch((err) => {
          this.checkErr(err);
        })
        .finally(() => {
          this.dialog = false;
        });
    },
    validateForm() {
      this.$emit('update:validate', new Promise((resolve, reject) => {
        if (this.image || this.$refs.form.validate()) {
          resolve(true);
        } else {
          reject(new Error(false));
        }
      }));
    },
  },
};
</script>

<style>
.withPopup .popup {
  display: none;
}

.withPopup:hover .popup {
  display: block;
}
</style>
